var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCustoms(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_397_574)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_397_574",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 26,
    height: 26
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26 0H0V26H26V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_397_574)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 16L7 23",
    stroke: "#0ABD19",
    strokeWidth: 1.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.92611 12C5.92611 12 6.38545 14.2675 5.00743 15.2357C3.6294 16.2038 1.3327 17.4968 1.10303 19.4395C0.965135 20.6206 1.00002 22 1.00006 23L1.10303 25.5H13.9996L14 25",
    stroke: "#0ABD19",
    strokeWidth: 1.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.59375 5.63672C3.59375 7.96925 4.1795 12.3414 7.40111 12.3414",
    stroke: "#0ABD19",
    strokeWidth: 1.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.07349 12C9.07349 12 8.61415 14.2662 9.99218 15.2338C11.3702 16.2014 13.6669 17.5 13.8966 19.4416C14.044 20.6877 14 21.5 14 23",
    stroke: "#0ABD19",
    strokeWidth: 1.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0574 5.63672C11.0574 7.96925 10.4716 12.3414 7.25 12.3414",
    stroke: "#0ABD19",
    strokeWidth: 1.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.27569 0.458984C8.61454 0.458984 9.24212 1.83967 10.7379 2.2999C12.2336 2.76013 12.7828 2.82289 12.8664 3.29881C12.9501 3.77473 11.9198 4.21927 11.7629 4.60105C11.7486 4.63694 11.7364 4.6736 11.7263 4.71088C11.6753 4.87638 11.5776 5.02364 11.4449 5.13496C11.3123 5.24629 11.1503 5.31695 10.9784 5.33847C9.75302 5.53236 8.51602 5.64418 7.27569 5.67318C6.03536 5.64418 4.79835 5.53236 3.57293 5.33847C3.40108 5.31695 3.23911 5.24629 3.10644 5.13496C2.97378 5.02364 2.87607 4.87638 2.82505 4.71088C2.81495 4.6736 2.80273 4.63694 2.78845 4.60105C2.63155 4.21927 1.60649 3.75904 1.68494 3.29881C1.76339 2.83858 2.31253 2.77582 3.8135 2.2999C5.31448 1.82398 5.94207 0.458984 7.27569 0.458984Z",
    stroke: "#0ABD19",
    strokeWidth: 1.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.57812 5.37109C3.57812 5.37109 4.20571 7.36368 7.28088 7.36368C10.3561 7.36368 10.9836 5.37109 10.9836 5.37109",
    stroke: "#0ABD19",
    strokeWidth: 1.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5886 23.0293H17V25.1945H24.5886V23.0293Z",
    stroke: "#0ABD19",
    strokeWidth: 1.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7243 20.1368L22.1094 17.5637C21.7417 17.2024 21.2468 17 20.7313 17C20.2158 17 19.721 17.2024 19.3532 17.5637L19.1807 17.731L24.5518 23.0289L24.7243 22.8615C24.9054 22.6838 25.0492 22.4718 25.1474 22.2379C25.2456 22.004 25.2962 21.7528 25.2962 21.4991C25.2962 21.2455 25.2456 20.9943 25.1474 20.7604C25.0492 20.5265 24.9054 20.3145 24.7243 20.1368Z",
    stroke: "#0ABD19",
    strokeWidth: 1.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_397_574"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustoms);
export default __webpack_public_path__ + "static/media/Customs.347b22e42d69fe07b5d585cf5b45e218.svg";
export { ForwardRef as ReactComponent };